import React from 'react';
import BzDropdownButton, { DropdownButtonItem } from '../buttons/BzDropdownButton';
import { MessagePropertyType, messagePropertyTypes } from '../../types/rest/dslTypes';

interface PropertyTypeDropdownProps {
  isReadOnly: boolean;
  selected: DropdownButtonItem;
  onSelect: (item: DropdownButtonItem) => void;
  id: string;
  isShortTitle: boolean;
  /** List of supported propertyTypes */
  propertyTypes: MessagePropertyType[];
}

const PropertyTypeDropdown = (props: PropertyTypeDropdownProps) => {
  const getItems = () => {
    return props.propertyTypes.map(
      item =>
        ({
          key: item,
          title: messagePropertyTypes[item],
        } as DropdownButtonItem),
    );
  };

  return (
    <BzDropdownButton
      disabled={props.isReadOnly}
      dropdownItems={getItems()}
      selectedItem={props.selected}
      onSelectedItem={props.onSelect}
      variant="secondary"
      id={'propType-' + props.id}
      shortTitle={props.isShortTitle}
    />
  );
};

export default PropertyTypeDropdown;
